import moment from 'moment';
import { funcWebViewHeight } from '@/utils/web-style/web-style';
import * as connectBikeAPI from '@/api/connect-bike';
import { funcEncryptData, funcDecryptData } from '@/utils/crypt';
import { mapGetters } from 'vuex';
export const connectJsBikeApi = {
  data () {
    return {
      bikeId: '',
      requestData: {},
      newBikeId: '',
      brandPrefix: 'QW',
      NewMID: '',
      getNewMIDType: '',
      frameNo: '',
      bikeModel: '',
      updateComponentStatus: {}
    };
  },
  mounted () {
    // 高度偵測
    funcWebViewHeight();
    this.funcConnectDate();
  },
  computed: {
    ...mapGetters({
      getBikeFlag: 'bikeConnect/getBikeFlag',
      getBikeFrameNo: 'bikeConnect/getBikeFrameNo'
    }),
    isNeedToGetConsoleMID () {
      if (this.requestData.ConsolePN === '') return false;
      if (this.requestData.ConsoleMID === '') return true;
      return false;
    },
    isNeedToGetDriverMID () {
      if (this.requestData.DriverPN === '') return false;
      if (this.requestData.DriverType === 'M') return false;
      if (this.requestData.DriverMID === '') return true;
      return false;
    },
    isNeedToGetDisplayMID () {
      if (this.requestData.DisplayPN === '') return false;
      if (this.requestData.DisplayMID === '') return true;
      return false;
    },
    isNeedToWriteMID () {
      if (
        !this.isNeedToGetConsoleMID &&
        !this.isNeedToGetDriverMID &&
        !this.isNeedToGetDriverMID
      ) { return false; }
      // console.log('computed 需要寫入MID')
      return true;
    }
  },
  methods: {
    funcConnectDate () {
      const date = moment().format('YYYY/MM/DD');
      this.$store.dispatch('bikeConnect/getCurrentDate', date);
    },
    async funcBindBikeId () {
      this.requestData.BikeFID = this.getBikeFrameNo;
      const encryptData = funcEncryptData(this.requestData);
      try {
        // console.log('API:bindBikeId() <-', this.requestData);
        const data = await connectBikeAPI.bindBikeId(encryptData)
          .then(res => funcDecryptData(JSON.parse(res)));
        // console.log('API:bindBikeId() ->', data);
        if (data.ErrorCode === 0) {
          this.newBikeId = data.NewBikeId;
          this.$store.dispatch('bikeConnect/getBikeId', this.newBikeId);

          const vin = data.frameNumber;
          this.$store.dispatch('bikeConnect/setBikeFrameNo', vin);
          this.ws.WriteFrameNo(vin);
        } else if (data.ErrorCode === 10013) {
          // different Bike model
          this.$router.push({ name: 'ConnectFailed', params: { fail: 'PNError' } });
        } else {
          this.$store.dispatch('bikeConnect/setConnFail', '[B01] ' + data.ErrorCode);
          this.$router.push({ name: 'ConnectFailed', params: { fail: 'APIError' } });
        }
      } catch (e) {
        this.$store.dispatch('bikeConnect/setConnFail', '[B01]');
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'APIError' } });
      }
    },
    async funcWriteBikeId () {
      if (this.bikeId === this.newBikeId) {
        this.ws.GetSystemInfo();
      } else {
        this.ws.WriteBikeId(this.newBikeId);
      }
    },
    async funcGetPartBrandPrefixAPI (consolePN) {
      // console.log('GetPartBrandPrefixAPI() <-', consolePN);
      let message = { PartNo: consolePN };
      const encryptData = funcEncryptData(message);
      var data = '';
      try {
        // console.log('API:getPartBrandPrefix() <-', message);
        data = await connectBikeAPI.getPartBrandPrefix(encryptData)
          .then(res => funcDecryptData(JSON.parse(res)));
        // console.log('API:getPartBrandPrefix() ->', data);
        // console.log('WEB:brandPrefix', this.brandPrefix);
        if (data.ErrorCode > 0) {
          this.$store.dispatch('bikeConnect/setConnFail', '[BR01] ' + data.ErrorCode);
          this.$router.push({ name: 'ConnectFailed', params: { fail: 'APIError' } });
        } else {
          // 判斷是否為QW的車子
          if (data.BrandPrefix !== this.brandPrefix) {
            this.$router.push({ name: 'ConnectFailed', params: { fail: 'BikeError' } });
          } else {
            this.ws.GetUpdateStatus();
          }
        }
      } catch (e) {
        this.$store.dispatch('bikeConnect/setConnFail', '[BR01] ');
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'APIError' } });
      }
    },
    funcCheckUpdateStatus (updateStatus) {
      // 確認零件是否有更新失敗
      let arrayUpdateStatus = Object.values(updateStatus);
      // console.log('arrayUpdateStatus',arrayUpdateStatus )
      if (arrayUpdateStatus.indexOf('N') > -1) {
        // 導到強制更新頁
        // console.log('導到強制更新頁')
        this.$router.push('re-fwupdate');
      } else {
        // 確認是否有MID
        // console.log('確認是否有MID')
        if (!this.funcCheckNeedToGetNewMID()) {
          // 不需要重新寫入MID，則跟車子拿VIN
          this.ws.GetFrameNumber();
        }
      }
    },
    funcCheckNeedToGetNewMID () {
      if (this.isNeedToGetConsoleMID) {
        this.funcGetNewMID_API('C', this.requestData.ConsolePN);
        this.getNewMIDType = 'C';
        // console.log("需寫入 C ")
        return true;
      }
      if (this.isNeedToGetDriverMID) {
        this.funcGetNewMID_API('D', this.requestData.DriverPN);
        this.getNewMIDType = 'D';
        // console.log("需寫入 D ")
        return true;
      }
      if (this.isNeedToGetDisplayMID) {
        this.funcGetNewMID_API('P', this.requestData.DisplayPN);
        this.getNewMIDType = 'P';
        // console.log("需寫入 P ")
        return true;
      }
      return false;
    },
    async funcGetNewMID_API (partType, partNo) {
      const encryptData = funcEncryptData(partNo);
      try {
        // console.log('API:getNewMID() <-', message);
        const data = await connectBikeAPI.getNewMID(encryptData)
          .then(res => funcDecryptData(JSON.parse(res)));
        // console.log('API:getNewMID() ->', data);
        if (data.ErrorCode === 0) {
          this.NewMID = data.NewMID;
          this.ws.WriteMid(partType, this.NewMID);
        } else {
          this.$store.dispatch('bikeConnect/setConnFail', '[MID01] ' + data.ErrorCode);
          this.$router.push({ name: 'ConnectFailed', params: { fail: 'APIError' } });
        }
      } catch (e) {
        this.$store.dispatch('bikeConnect/setConnFail', '[MID01]');
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'APIError' } });
      }
    },
    async funcCheckPN_API () {
      // note:要把VID一起放入message中
      let bikeFID = { BikeFID: this.getBikeFrameNo };
      let message = Object.assign({}, this.requestData, bikeFID);
      const encryptData = funcEncryptData(message);
      // console.log(message);
      // call check PN API
      try {
        // console.log('API:compareBikeParts() <-', message);
        const data = await connectBikeAPI.compareBikeParts(encryptData)
          .then(res => funcDecryptData(JSON.parse(res)));
        // console.log('API:compareBikeParts() ->', data);
        if (data.ErrorCode > 0) {
          let msg = `[C01]` + data.ErrorCode;
          this.$store.dispatch('bikeConnect/setConnFail', msg);
          this.$router.push({
            name: 'ConnectFailed',
            params: { fail: 'APIError' }
          });
          return;
        }
        let connectTypeCode = parseInt(data.CompareType);
        if (connectTypeCode === 3) {
          this.frameNo = data.VIN;
          // console.log('VIV', this.frameNo);
          this.$store.dispatch('bikeConnect/setBikeFrameNo', this.frameNo);
        }
        let connectTypeFunc = this.accordingConnectType(connectTypeCode);
        connectTypeFunc();
      } catch (e) {
        let msg = `[C01]`;
        this.$store.dispatch('bikeConnect/setConnFail', msg);
        this.$router.push({
          name: 'ConnectFailed',
          params: { fail: 'APIError' }
        });
      }
    },
    accordingConnectType (connectType) { //! 根據連線類型切換 route
      // implement method
      let dicFuncTypeTable = {
        1: this.funcDirectIntoWHDA,
        2: this.funcBindNewFrameNo,
        3: this.funcReBindFrameNoDB,
        4: this.funcConfirmReplaceData,
        5: this.funcBlockWHDA
      };
      let ConnSituation = dicFuncTypeTable[connectType];
      let dictConnectType = { ConnectType: connectType };
      this.$store.dispatch(
        'bikeConnect/setBikeConnectSituation',
        dictConnectType
      );
      return ConnSituation;
    },
    async funcGetBikeInfo_API () {
      // 搜尋 DriverMID 的Frame NO
      let message = { FrameNo: '', MID: this.requestData.DriverMID };
      const encryptData = funcEncryptData(message);
      // console.log('API:getBikeInfo() <-', message);
      const data = await connectBikeAPI.getBikeInfo(encryptData)
        .then(res => funcDecryptData(JSON.parse(res)));
      // console.log('API:getBikeInfo() ->', data);
      if (data.ErrorCode === 0) {
        let frameNo = data.BikeInfo.FrameNo;
        this.$store.dispatch('bikeConnect/setBikeFrameNo', frameNo);
        this.$router.push('/vinrecheck');
        // 跳至確認 FrameNo 的頁面
      } else {
        this.$store.dispatch('bikeConnect/setConnFail', '[BI01]');
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'APIError' } });
      }
    },
    async funcBindBikeModel () {
      let bikeFID = { FrameNo: this.getBikeFrameNo };
      const encryptData = funcEncryptData(bikeFID);
      // console.log('API:getBikeModel() <-', bikeFID);
      const data = await connectBikeAPI.getBikeModel(encryptData)
        .then(res => funcDecryptData(JSON.parse(res)));
      // console.log('API:getBikeModel() ->', data);
      if (data.ErrorCode === 0) {
        this.bikeModel = data.BikeModel;
        this.$store.dispatch('bikeInformation/addBikeModel', this.bikeModel);
      } else {
        this.$store.dispatch('bikeConnect/setConnFail', '[BM01]');
        this.$router.push({ name: 'ConnectFailed', params: { fail: 'APIError' } });
      }
    },
    funcDirectIntoWHDA () {
      // 1
      // bind Bike ID
      // get system Info
      this.funcBindBikeId();
    },
    funcBindNewFrameNo () {
      /**
       * 情況 2
       * Keyin VIN -> Recheck VIN page -> BindBikeID、BindVIN (DB Recheck PN)
       * Recheck PN Pass -> WHDA
       * Recheck PN Failed -> Failed page
       */
      this.$router.push('/writevin');
    },
    funcReBindFrameNoDB () {
      // 3
      // 寫入VIN to device
      this.funcBindBikeId();
    },
    funcConfirmReplaceData () {
      // 4
      // 透過 MID 去 DB 拿 frame No
      // ws write frame no
      // bind bikeid
      // getSystemInfo
      this.$router.push('/coverbikedata');
    },
    funcBlockWHDA () {
      // 5 無法進入 WHDA
      this.$router.push({ name: 'ConnectFailed', params: { fail: 'PNError' } });
    }
  }
};
